import React from 'react';
import {SITE_LIST,PREFILLED_GATE_DATA,SAVE_RENEWAL_REQUEST,PREFILLED_REQUEST,REQUEST_LIST,UPDATE_REQUEST_STATUS,REQUEST_DETAILS,FILTERS,PREVIOUS_REQUESTS,BASE_PRICES,UPDATE_CLIENT_STATUS,CLIENT_STATUS_OPTIONS} from "./type";

const initalState = {
    siteList: null,
    prefilledGateData: null,
    renewalRequest: null,
    prefilledRequestData: null,
    requestList:null,
    requestStatus:null,
    requestDetails:null,
    filters:null,
    previousRequests:null,
    basePrices:null,
    clientStatusUpdate:null,
    clientStatusOptions:null,
};

const contractRenewalReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SITE_LIST:
            return {
                ...state,
                siteList: payload,
            };
        case PREFILLED_GATE_DATA:
            return {
                ...state,
                prefilledGateData: payload,
            };
        case SAVE_RENEWAL_REQUEST:
            return {
                ...state,
                renewalRequest: payload,
            };
        case PREFILLED_REQUEST:
            return {
                ...state,
                prefilledRequestData: payload,
            };
        case REQUEST_LIST:
            return {
                ...state,
                requestList: payload,
            };
        case UPDATE_REQUEST_STATUS:
            return {
                ...state,
                requestStatus: payload,
            };
        case REQUEST_DETAILS:
            return {
                ...state,
                requestDetails: payload,
            };
        case FILTERS:
            return {
                ...state,
                filters: payload,
            };
        case PREVIOUS_REQUESTS:
            return {
                ...state,
                previousRequests: payload,
            };
        case BASE_PRICES:
            return {
                ...state,
                basePrices: payload,
            };
        case UPDATE_CLIENT_STATUS:
            return {
                ...state,
            clientStatusUpdate: payload
            };
        case CLIENT_STATUS_OPTIONS:
            return {
                ...state,
            clientStatusOptions: payload
        };
        default:
            return {
                ...state,
            };
    }
};

export default contractRenewalReducer
